<app-paidheader></app-paidheader>
<router-outlet></router-outlet>
<app-paidfooter></app-paidfooter>